import { render, staticRenderFns } from "./PoliciesMortgage.vue?vue&type=template&id=007924ea"
import script from "./PoliciesMortgage.vue?vue&type=script&lang=js"
export * from "./PoliciesMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports